import { CommonSingleAccordion } from 'components/common/accordion/single';
import { ErrorBoundary } from 'components/common/error-boundary';
import { PitchUploadDesigner } from 'components/sections/pitch-uploader/designer';
import { PitchUploaderFileControls } from 'components/sections/pitch-uploader/file-controls';
import { PitchUploaderPreview } from 'components/sections/pitch-uploader/preview';
import { PitchUploadStep } from 'enums/pitch-uploader';
import { usePitchUploaderStore } from 'stores/use-pitch-uploader-store';

export const PitchUploaderBody = () => {
  const step = usePitchUploaderStore((s) => s.step);

  return (
    <ErrorBoundary identifier="PitchUploaderBody">
      <CommonSingleAccordion
        type="single"
        value={step}
        onValueChange={(v) =>
          usePitchUploaderStore.setState({
            step: v as PitchUploadStep,
          })
        }
        items={[
          {
            label: 'common.file-upload',
            value: PitchUploadStep.upload,
            children: <PitchUploaderFileControls />,
          },
          {
            label: 'common.preview-results',
            value: PitchUploadStep.preview,
            children: <PitchUploaderPreview />,
          },
          {
            label: 'main.pitch-design',
            value: PitchUploadStep.design,
            children: <PitchUploadDesigner />,
          },
        ]}
      />
    </ErrorBoundary>
  );
};
